import store from '/@/store'
import { getRoot } from '/@/root'
import { ELocalStorageKey, EDeviceTypeName } from '/@/types'
import { getDeviceBySn } from '/@/api/manage'
import { message } from 'ant-design-vue'
import type { Polyline } from 'leaflet'

export function deviceTsaUpdate () {
  const root = getRoot() as any
  const L = root.$leaflet
  const map = root.$map

  // Check if Leaflet is available
  if (!L || !map) {
    console.warn('Leaflet or Map not available yet')
    return {
      initMarker: () => { },
      moveTo: () => { }
    }
  }

  const icons = new Map([
    [EDeviceTypeName.Aircraft, L.icon({
      iconUrl: '/assets/icons/drone.png',
      iconSize: [40, 40],
      iconAnchor: [20, 20]
    })],
    [EDeviceTypeName.Gateway, L.icon({
      iconUrl: '/assets/icons/rc.png',
      iconSize: [40, 40],
      iconAnchor: [20, 20]
    })],
    [EDeviceTypeName.Dock, L.icon({
      iconUrl: '/assets/icons/dock.png',
      iconSize: [40, 40],
      iconAnchor: [20, 20]
    })]
  ])

  // Get markers from store - this will be shared across all instances
  const markers = store.state.markerInfo.coverMap
  const paths = store.state.markerInfo.pathMap

  let trackLine: Polyline | null = null

  function getTrackLineInstance () {
    if (!trackLine && map) {
      trackLine = L.polyline([], {
        color: '#939393',
        weight: 2
      }).addTo(map)
    }
    return trackLine
  }

  function initMarker (type: number, name: string, sn: string, lng?: number, lat?: number) {
    // Check if marker already exists and is on the map
    if (markers[sn]) {
      // If marker exists but map has been reinitialized, re-add it to the map
      if (map && !map.hasLayer(markers[sn])) {
        markers[sn].addTo(map)
      }
      return
    }

    if (!L || !map) {
      console.warn('Cannot create marker - Leaflet or Map not available')
      return
    }

    // Use default coordinates if none provided
    const latitude = lat || 22.577673716
    const longitude = lng || 113.943225499

    try {
      const marker = L.marker([latitude, longitude], {
        icon: icons.get(type),
        title: name
      })

      // Add marker to map
      marker.addTo(map)

      // Store marker in global store
      markers[sn] = marker
    } catch (error) {
      console.error(`Error creating marker for ${sn}:`, error)
    }
  }

  function moveTo (sn: string, lng: number, lat: number) {
    if (markers[sn]) {
      try {
        markers[sn].setLatLng([lat, lng])
      } catch (error) {
        console.error(`Error moving marker ${sn}:`, error)
      }
    } else {
      console.warn(`Cannot move marker ${sn} - marker not found`)
    }
  }

  // Add a cleanup function to remove markers when component unmounts
  function cleanup () {
    Object.keys(markers).forEach(sn => {
      if (markers[sn] && map && map.hasLayer(markers[sn])) {
        map.removeLayer(markers[sn])
      }
    })
    if (trackLine && map && map.hasLayer(trackLine)) {
      map.removeLayer(trackLine)
    }
  }

  return {
    initMarker,
    moveTo,
    cleanup
  }
}
